<div class="main-content side-content pt-0 ml-0">
    <div class="main-container container-fluid">
        <div class="inner-body">
            <!-- Page Header -->
            <div class="page-header">
                <div>
                    <h2 class="main-content-title tx-18 mg-b-5">All Students Data</h2>
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="#">Students Data</a></li>
                        <li class="breadcrumb-item active" aria-current="page">Add Student</li>
                    </ol>
                </div>
                <div class="d-flex">
                    <div class="justify-content-center">
                        <button type="button" class="btn btn-white btn-icon-text my-2 me-2">
                          <i class="fe fe-download me-2"></i> Import
                        </button>
                        <button type="button" class="btn btn-white btn-icon-text my-2 me-2">
                          <i class="fe fe-filter me-2"></i> Filter
                        </button>
                        <button type="button" class="btn btn-primary my-2 btn-icon-text">
                          <i class="fe fe-download-cloud me-2"></i> Download Report
                        </button>
                    </div>
                </div>
            </div>
            <!-- End Page Header -->

            <!-- Row -->
            <<div class="row row-sm">
                <div class="col-lg-12">
                    <div class="card custom-card">
                        <div class="card-body">
                            <div>
                                <h6 class="main-content-label mb-1">All Students Record</h6>
                                <p class="text-muted card-sub-title">Students Data Information</p>
                            </div>
                            <div class="row form-data">
                                <div class="col-lg-12">
                                    <div class="row align-items-center">
                                        <div class="col-md-3 my-2 my-md-0">
                                            <div class="form-group">
                                                <div class="input-icon">
                                                    <input type="text" class="form-control search" placeholder="Search .." id="datatable_search_query">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3 my-2 my-md-0">
                                            <div class="d-flex align-items-center">
                                                <label class="mr-3 mb-0 mt-2 d-none d-md-block">Status:</label>
                                                <div class="form-group">
                                                    <select name="country" class="form-control select-lg select2">
                                                        <option value="">Select</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3 my-2 my-md-0">
                                            <div class="d-flex align-items-center">
                                                <label class="mr-3 mb-0 mt-2 d-none d-md-block">Type:</label>										
                                                <div class="form-group">
                                                    <select name="country" class="form-control select-lg select2">
                                                        <option value="">Select</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-3">
                                            <a href="#" class="btn btn-light-primary">Search</a>
                                            <a href="student-form" class="btn btn-light-primary">Add</a>
                                        </div>
                                      
                                        
                                    </div>
                                </div>
                            </div>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-striped table-bordered text-nowrap" >
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Roll No</th>
                                            <th>Name</th>
                                            <th>Department</th>
                                            <th>Admission Date</th>
                                            <th>Status</th>
                                            <th>Type</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody id="table_data">
                                        <tr>
                                            <td>01</td>
                                            <td>24236 - 009</td>
                                            <td>John Deo</td>
                                            <td>Computer</td>
                                            <td>15-05-2022</td>
                                            <td><span class="label-light-primary">Cancelled </span></td>
                                            <td class="text-success">• Direct</td>
                                            <td class="text-center">
                                                <a class="btn-floating" data-bs-target="#modaldemo4" data-bs-toggle="modal" title="Cog">
                                                    <i class="fa fa-cog"></i>
                                                </a>
                                                <a class="btn-floating" title="Edit">
                                                    <i class="fa fa-edit"></i>
                                                </a> 
                                                <a class="btn-floating" title="Delete">
                                                    <i class="fas fa-trash"></i>
                                                </a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>02</td>
                                            <td>24236 - 009</td>
                                            <td>John Deo</td>
                                            <td>Computer</td>
                                            <td>15-05-2022</td>
                                            <td><span class="label-light-danger">Danger </span></td>
                                            <td class="text-danger">• Direct</td>
                                            <td class="text-center">
                                                <a class="btn-floating" data-bs-target="#modaldemo4" data-bs-toggle="modal" title="Cog">
                                                    <i class="fa fa-cog"></i>
                                                </a>
                                                <a class="btn-floating" title="Edit">
                                                    <i class="fa fa-edit"></i>
                                                </a> 
                                                <a class="btn-floating" title="Delete">
                                                    <i class="fas fa-trash"></i>
                                                </a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>03</td>
                                            <td>24236 - 009</td>
                                            <td>John Deo</td>
                                            <td>Computer</td>
                                            <td>15-05-2022</td>
                                            <td><span class="label-light-info">Info</span></td>
                                            <td class="text-danger">• Direct</td>
                                            <td class="text-center">
                                                <a class="btn-floating" data-bs-target="#modaldemo4" data-bs-toggle="modal" title="Cog">
                                                    <i class="fa fa-cog"></i>
                                                </a>
                                                <a class="btn-floating" title="Edit">
                                                    <i class="fa fa-edit"></i>
                                                </a> 
                                                <a class="btn-floating" title="Delete">
                                                    <i class="fas fa-trash"></i>
                                                </a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>04</td>
                                            <td>24236 - 009</td>
                                            <td>John Deo</td>
                                            <td>Computer</td>
                                            <td>15-05-2022</td>
                                            <td><span class="label-light-primary">Cancelled </span></td>
                                            <td class="text-success">• Direct</td>
                                            <td class="text-center">
                                                <a class="btn-floating" data-bs-target="#modaldemo4" data-bs-toggle="modal" title="Cog">
                                                    <i class="fa fa-cog"></i>
                                                </a>
                                                <a class="btn-floating" title="Edit">
                                                    <i class="fa fa-edit"></i>
                                                </a> 
                                                <a class="btn-floating" title="Delete">
                                                    <i class="fas fa-trash"></i>
                                                </a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>05</td>
                                            <td>24236 - 009</td>
                                            <td>John Deo</td>
                                            <td>Computer</td>
                                            <td>15-05-2022</td>
                                            <td><span class="label-light-danger">Danger </span></td>
                                            <td class="text-primary">• Direct</td>
                                            <td class="text-center">
                                                <a class="btn-floating" data-bs-target="#modaldemo4" data-bs-toggle="modal" title="Cog">
                                                    <i class="fa fa-cog"></i>
                                                </a>
                                                <a class="btn-floating" title="Edit">
                                                    <i class="fa fa-edit"></i>
                                                </a> 
                                                <a class="btn-floating" title="Delete">
                                                    <i class="fas fa-trash"></i>
                                                </a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>06</td>
                                            <td>24236 - 009</td>
                                            <td>John Deo</td>
                                            <td>Computer</td>
                                            <td>15-05-2022</td>
                                            <td><span class="label-light-info">Info</span></td>
                                            <td class="text-success">• Direct</td>
                                            <td class="text-center">
                                                <a class="btn-floating" data-bs-target="#modaldemo4" data-bs-toggle="modal" title="Cog">
                                                    <i class="fa fa-cog"></i>
                                                </a>
                                                <a class="btn-floating" title="Edit">
                                                    <i class="fa fa-edit"></i>
                                                </a> 
                                                <a class="btn-floating" title="Delete">
                                                    <i class="fas fa-trash"></i>
                                                </a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>07</td>
                                            <td>24236 - 009</td>
                                            <td>John Deo</td>
                                            <td>Computer</td>
                                            <td>15-05-2022</td>
                                            <td><span class="label-light-primary">Cancelled </span></td>
                                            <td class="text-danger">• Direct</td>
                                            <td class="text-center">
                                                <a class="btn-floating" data-bs-target="#modaldemo4" data-bs-toggle="modal" title="Cog">
                                                    <i class="fa fa-cog"></i>
                                                </a>
                                                <a class="btn-floating" title="Edit">
                                                    <i class="fa fa-edit"></i>
                                                </a> 
                                                <a class="btn-floating" title="Delete">
                                                    <i class="fas fa-trash"></i>
                                                </a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>08</td>
                                            <td>24236 - 009</td>
                                            <td>John Deo</td>
                                            <td>Computer</td>
                                            <td>15-05-2022</td>
                                            <td><span class="label-light-danger">Danger </span></td>
                                            <td class="text-primary">• Direct</td>
                                            <td class="text-center">
                                                <a class="btn-floating" data-bs-target="#modaldemo4" data-bs-toggle="modal" title="Cog">
                                                    <i class="fa fa-cog"></i>
                                                </a>
                                                <a class="btn-floating" title="Edit">
                                                    <i class="fa fa-edit"></i>
                                                </a> 
                                                <a class="btn-floating" title="Delete">
                                                    <i class="fas fa-trash"></i>
                                                </a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>09</td>
                                            <td>24236 - 009</td>
                                            <td>John Deo</td>
                                            <td>Computer</td>
                                            <td>15-05-2022</td>
                                            <td><span class="label-light-info">Info</span></td>
                                            <td class="text-success">• Direct</td>
                                            <td class="text-center">
                                                <a class="btn-floating" data-bs-target="#modaldemo4" data-bs-toggle="modal" title="Cog">
                                                    <i class="fa fa-cog"></i>
                                                </a>
                                                <a class="btn-floating" title="Edit">
                                                    <i class="fa fa-edit"></i>
                                                </a> 
                                                <a class="btn-floating" title="Delete">
                                                    <i class="fas fa-trash"></i>
                                                </a>
                                            </td>	
                                        </tr>
                                        <tr>
                                            <td>10</td>
                                            <td>24236 - 009</td>
                                            <td>John Deo</td>
                                            <td>Computer</td>
                                            <td>15-05-2022</td>
                                            <td><span class="label-light-primary">Cancelled </span></td>
                                            <td class="text-success">• Direct</td>
                                            <td class="text-center">
                                                <a class="btn-floating" data-bs-target="#modaldemo4" data-bs-toggle="modal" title="Cog">
                                                    <i class="fa fa-cog"></i>
                                                </a>
                                                <a class="btn-floating" title="Edit">
                                                    <i class="fa fa-edit"></i>
                                                </a> 
                                                <a class="btn-floating" title="Delete">
                                                    <i class="fas fa-trash"></i>
                                                </a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>11</td>
                                            <td>24236 - 009</td>
                                            <td>John Deo</td>
                                            <td>Computer</td>
                                            <td>15-05-2022</td>
                                            <td><span class="label-light-danger">Danger </span></td>
                                            <td class="text-success">• Direct</td>
                                            <td class="text-center">
                                                <a class="btn-floating" data-bs-target="#modaldemo4" data-bs-toggle="modal" title="Cog">
                                                    <i class="fa fa-cog"></i>
                                                </a>
                                                <a class="btn-floating" title="Edit">
                                                    <i class="fa fa-edit"></i>
                                                </a> 
                                                <a class="btn-floating" title="Delete">
                                                    <i class="fas fa-trash"></i>
                                                </a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>12</td>
                                            <td>24236 - 009</td>
                                            <td>John Deo</td>
                                            <td>Computer</td>
                                            <td>15-05-2022</td>
                                            <td><span class="label-light-info">Info</span></td>
                                            <td class="text-success">• Direct</td>
                                            <td class="text-center">
                                                <a class="btn-floating" data-bs-target="#modaldemo4" data-bs-toggle="modal" title="Cog">
                                                    <i class="fa fa-cog"></i>
                                                </a>
                                                <a class="btn-floating" title="Edit">
                                                    <i class="fa fa-edit"></i>
                                                </a> 
                                                <a class="btn-floating" title="Delete">
                                                    <i class="fas fa-trash"></i>
                                                </a>
                                            </td>	
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>							
        </div>
    </div>        
</div>